import domain from './domain';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import {
    UserSpaceParticipationResource,
    UserSpaceResource,
} from 'dy-frontend-http-repository/lib/modules/UserSpace/resources';
import repository from 'dy-frontend-http-repository/lib/repository';
import {
    AddUserSpaceParticipantInput,
    CreateUserSpaceInviteInput,
    UserSpaceFilterInput,
} from 'dy-frontend-http-repository/lib/modules/UserSpace/inputs';
import { UserSpaceRef } from 'dy-frontend-http-repository/lib/modules/UserSpace/refs';

// Get participation list for specific user space
export const fetchClientTeamMembers = domain.createEffect<ID, CollectionResource<UserSpaceParticipationResource, {}>>({
    name: 'fetchClientTeamMembers',
    handler: async (id) => {
        return await repository.userSpace().getParticipationForUserSpace(id);
    },
});

// Remove participating user from space
export const removeClientTeamMember = domain.createEffect<{ userSpaceId: ID; participantUserId: ID }, UserSpaceRef>({
    name: 'removeClientTeamMember',
    handler: async ({ userSpaceId, participantUserId }) => {
        return await repository.userSpace().removeParticipation(userSpaceId, participantUserId);
    },
});

// Fetch list of user spaces by participant ID
export const fetchClientTeamParticipationList = domain.createEffect<
    UserSpaceFilterInput,
    CollectionResource<UserSpaceResource, {}>
>({
    name: 'fetchClientTeamParticipationList',
    handler: async (input) => {
        return await repository.userSpace().get(input);
    },
});

// Create new user space invite
export const inviteUserToUserSpace = domain.createEffect<CreateUserSpaceInviteInput, UserSpaceRef>({
    name: 'inviteUserToUserSpace',
    handler: async (input) => {
        return await repository.userSpace().createInvite(input);
    },
});

// Add new participant to user space
export const addParticipant = domain.createEffect<
    { userSpaceId: ID; input: AddUserSpaceParticipantInput },
    UserSpaceRef
>({
    name: 'inviteUserToUserSpace',
    handler: async ({ userSpaceId, input }) => {
        return await repository.userSpace().addParticipant(userSpaceId, input);
    },
});
